import SlimSelect from 'slim-select'

document.addEventListener('DOMContentLoaded', () => {

  const block = document.querySelectorAll('.nxa-block-news-nexipedia-reference-teaser');
  if (block.length === 0) return;

  block.forEach(block => {

    new SlimSelect({
      select: '#taxonomy-select-category',
      settings: {
        showSearch: false
      }
    });

    let animating = false;
    const links = block.querySelector('.taxonomy-list.level-1');
    const heightToggle = block.querySelector('.height-toggle');
    const icon = heightToggle.querySelector('svg');
    const showMore = heightToggle.querySelector('.show-more');
    const showLess = heightToggle.querySelector('.show-less');
    const maxHeight = () => 163;

    const updateUI = expanded => {
      heightToggle.setAttribute('aria-expanded', expanded);
      icon.classList.toggle('flip', expanded);
      showMore.style.display = expanded ? 'none' : '';
      showLess.style.display = expanded ? '' : 'none';
    };

    const resizeObserver = new ResizeObserver(() => {
      if (animating) return;
      if (links.scrollHeight > maxHeight() && heightToggle.getAttribute('aria-expanded') === 'false') {
        updateUI(false);
        heightToggle.removeAttribute('style');
        links.style.maxHeight = maxHeight() + 'px';
      }
      if (links.scrollHeight <= maxHeight()) {
        updateUI(false);
        heightToggle.style.display = 'none';
        links.style.maxHeight = '';
      }
    });
    if (links) {
      resizeObserver.observe(links);
    }

    const toggle = e => {
      if (!animating && (e.type === 'click' || e.key === 'Enter' || e.key === ' ')) {
        animating = true;
        if (links.clientHeight < links.scrollHeight) {
          updateUI(true);
          links.style.maxHeight = `${links.scrollHeight}px`;
          links.addEventListener('transitionend', () => {
            links.style.maxHeight = '';
            animating = false;
          }, { once: true });
        } else {
          updateUI(false);
          links.style.maxHeight = links.scrollHeight + 'px';
          requestAnimationFrame(() => {
            links.style.maxHeight = maxHeight() + 'px';
          })
          links.addEventListener('transitionend', () => {
            animating = false;
          }, { once: true });
        }
      }
    }
    heightToggle.addEventListener('keydown', toggle);
    heightToggle.addEventListener('click', toggle);

  });

});
